var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-tooltip',{attrs:{"tooltip":_vm.tooltip,"label":_vm.label,"size":"is-small","type":"is-light","multilined":"","icon-left":_vm.icon},on:{"click":_vm.copyToClipboard}})}
var staticRenderFns = []

export { render, staticRenderFns }